export default __webpack_public_path__ + "static/media/adventuretime.d58274d5.jpg";